import React from "react";
import {connect} from 'react-redux'
import _ from 'lodash'
import withStyles from "@material-ui/core/styles/withStyles";
import Checkbox from "@material-ui/core/Checkbox";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import Button from "components/CustomButtons/Button.jsx";
import Close from "@material-ui/icons/Close";
const styles = {
	modal:{
    position: 'fixed',
    zIndex: '2000',
    left: '0',
    top: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  modalContent: {
    width: '80%',
    maxWidth: '500px',
    border: 'solid 1px gray',
    backgroundColor: 'white',
    padding: '15px',
    paddingLeft: '30px'
  },
  modalHeader:{
    paddingBottom: '20px'
  }
}
class SymbolsModal extends React.Component {
    componentWillMount(){
      const{groups} = this.props
      let symbols = []
      groups.filter((g)=> !g.groupedBy).forEach((s) => {
        let checked = this.props.selected.symbols.find((a)=> a.symbolId === s.symbolId)
        s.children.forEach((child) => {
          let checkedChild = this.props.selected.symbols.find((a)=> a.symbolId === child.symbolId)
          child.checked = checkedChild ? true : false
          symbols.push({id:child.symbolId, checked:checkedChild? true: false, expand:false})
        })
        let expandBase = s.children.some((c) => c.checked)
        symbols.push({id:s.symbolId, checked:checked? true: false, expand:expandBase})
      })

      let groups1 = groups.filter((g) => g.groupedBy).map((v) => {
        let checked = this.props.selected.symbolGroups.includes(v.groupedBy)
        let expandBase = false
        v.baseSymbols.forEach((base)=> {
          let checkedBase = this.props.selected.symbols.find((a)=> a.symbolId === base.symbolId)
          
          base.children.forEach((child) => {
            let checkedChild = this.props.selected.symbols.find((a)=> a.symbolId === child.symbolId)
            child.checked = checkedChild ? true: false
            symbols.push({id:child.symbolId, checked:checkedChild? true: false, expand:false})
          })
          expandBase = base.children.some((c) => c.checked)
          base.checked = checkedBase? true: false
          symbols.push({id:base.symbolId, checked:checkedBase? true: false, expand:expandBase})
        })

        let expandGroup = v.baseSymbols.some((c) => c.checked) || expandBase ? true : false
        return{id:v.groupedBy, checked:checked? true: false, expand:expandGroup}
      })
      
      this.setState({selectedGroups: groups1, selectedSymbols: symbols})
    }
    expandGroup(id){
      let {selectedGroups} = this.state
      let oldVal = selectedGroups.find((x) => x.id === id).expand
      selectedGroups.find((x) => x.id === id).expand = !oldVal
      this.setState({...this.state, selectedGroups})
    }
    expandSymbol(id){
      let {selectedSymbols} = this.state
      let oldVal = selectedSymbols.find((x) => x.id === id).expand
      selectedSymbols.find((x) => x.id === id).expand = !oldVal
      this.setState({...this.state, selectedSymbols})
    }
    checkGroup(id){
      let {selectedGroups} = this.state
      let oldVal = selectedGroups.find((x) => x.id === id).checked
      selectedGroups.find((x) => x.id === id).checked = !oldVal
      this.setState({...this.state, selectedGroups})
    }
    checkSymbol(id){
      let {selectedSymbols} = this.state
      let oldVal = selectedSymbols.find((x) => x.id === id).checked
      selectedSymbols.find((x) => x.id === id).checked = !oldVal
      this.setState({...this.state, selectedSymbols})
    }
    renderGroup(group, i){
      const {selectedGroups, selectedSymbols} = this.state
      const {symbolGroups} = this.props
      let groupObj = symbolGroups.find((a) => a.symbolGroupId === group.groupedBy)
      let checkGroup = selectedGroups.find((a) => a.id === groupObj.symbolGroupId)
      return(
        <div key={i}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Checkbox checked={checkGroup.checked} onChange={(e) => this.checkGroup(groupObj.symbolGroupId)} style={{height: '28px', color: '#00acc1'}}></Checkbox>
            <KeyboardArrowRight onClick={() => this.expandGroup(group.groupedBy)} style={{color: 'silver', fontSize: '30px', cursor: 'pointer'}} />
            <span>{groupObj.name}</span>
          </div>
          <div style={{paddingLeft: '40px', display: checkGroup.expand ? 'inherit' : 'none'}}>
            {group.baseSymbols.map((base, ind) => {
              let checkedBase = selectedSymbols.find((s) => s.id === base.symbolId)
              if(base.children.length !== 0){
                base.children = _(base.children).orderBy((bsc)=> bsc.name, 'asc').value()
                return(
                  <div key={ind} style={{width:'100%'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                      <Checkbox checked={checkedBase.checked} onChange={() => this.checkSymbol(base.symbolId)} style={{height: '28px', color: '#00acc1'}}></Checkbox>
                      <KeyboardArrowRight onClick={() => this.expandSymbol(base.symbolId)} style={{color: 'silver', fontSize: '30px', cursor: 'pointer'}} />
                      <span>{base.name}</span>
                    </div>
                    <div style={{paddingLeft: '40px', display: checkedBase.expand ? 'inherit' : 'none'}}>
                        {base.children.map((child, k) => {
                          let checkedChild = selectedSymbols.find((s) => s.id === child.symbolId)
                          return(
                            <div key={k} style={{display: 'flex', alignItems: 'center'}}>
                              <Checkbox checked={checkedChild.checked} onChange={() => this.checkSymbol(child.symbolId)} style={{height: '28px', color: '#00acc1'}}></Checkbox>
                              <span>{child.name}</span>
                            </div>
                          )
                        })}
                    </div>
                  </div>
                )
              } else{
                return(
                  <div key={ind} style={{display: 'flex', alignItems: 'center'}}>
                    <Checkbox checked={checkedBase.checked} onChange={() => this.checkSymbol(base.symbolId)} style={{height: '28px', color: '#00acc1'}}></Checkbox>
                    <span>{base.name}</span>
                  </div>
                )
              }
            })}
          </div>
        </div>
      )
    }
    renderSymbols(symbol, i){
      const {selectedSymbols} = this.state
      let checkedSymb = selectedSymbols.find((s) => s.id === symbol.symbolId)
      symbol.children = _(symbol.children).orderBy((bsc)=> bsc.name, 'asc').value()
      return(
        <div key={i}>
          <div style={{display: 'flex', alignItems: 'center'}}>
            <Checkbox checked={checkedSymb.checked} onChange={() => this.checkSymbol(symbol.symbolId)} style={{height: '28px', color: '#00acc1'}}></Checkbox>
            {symbol.children.length !== 0 && <KeyboardArrowRight onClick={() => this.expandSymbol(symbol.symbolId)} style={{color: 'silver', fontSize: '30px', cursor: 'pointer'}} />}
            <span>{symbol.name}</span>
          </div>
          {symbol.children.length !== 0 && 
            <div style={{paddingLeft: '40px', display: checkedSymb.expand ? 'inherit' : 'none'}}>
              {symbol.children.map((child, ind) => {
                let checkedChild = selectedSymbols.find((s) => s.id === child.symbolId)
                return(
                  <div key={ind} style={{display: 'flex', alignItems: 'center'}}>
                    <Checkbox checked={checkedChild.checked} onChange={() => this.checkSymbol(child.symbolId)} style={{height: '28px', color: '#00acc1'}}></Checkbox>
                    <span>{child.name}</span>
                  </div>
                )
              })}
            </div>
          }
        </div>
      )
    }
    close(){
      this.props.close()
    }
    save(){
      const {selectedGroups, selectedSymbols} = this.state
      let symbolGroups = selectedGroups.filter((x) => x.checked).map((x) => x.id)
      let symbols = selectedSymbols.filter((x) => x.checked).map((x) => x.id)
      let id = this.props.selected.profileSpecialCaseId
        ? this.props.selected.profileSpecialCaseId
        : this.props.selected.subProfileRuleId
      this.props.save(id, {symbolGroups, symbols})
      this.close()
    }
    render() {
      const {classes, groups} = this.props
      let symbolGroups = [...groups.filter((x) => x.groupedBy)]
      symbolGroups = symbolGroups.map((g)=> {
        g.baseSymbols = _(g.baseSymbols).orderBy((bs) => bs.name, 'asc').value()
        return g
      })
      
      let symbols = [...groups.filter((x) => !x.groupedBy)]
      symbols = _(symbols).orderBy((s) => s.name, 'asc').value()

      return (
        <div className={classes.modal}>
          <div className={classes.modalContent}>
            <div className={classes.modalHeader}>
              <span style={{fontSize: '16px'}}>Select Symbols</span>
              <Close onClick={() => this.close()} style={{fontSize: '16px', color: 'gray', float: 'right', cursor: 'pointer'}} />
            </div>
            <div style={{paddingBottom: '20px'}}>
              <p style={{color: 'silver', fontSize: '12px'}}>You can select the symbols you prefer or deselect what not.</p>
            </div>

            <div style={{padding:'15px', border: '1px solid silver', height: '250px', overflowX: 'auto'}}>
              {symbolGroups.map((group, i) => {
                return this.renderGroup(group, i)
              })}
              {symbols.map((symbol, i) => {
                return this.renderSymbols(symbol, i)
              })}
            </div>

            <div style={{paddingTop:'15px',textAlign: 'right'}}>
              <Button
								color="danger"
                type="button"
                onClick={()=> this.close()}
							>
								Cancel
							</Button>
              <Button
								color="success"
                type="button"
                onClick={()=> this.save()}
								style={{marginLeft: '20px'}}
							>
								Add
							</Button>
            </div>
          </div>
        </div>
      )
    }
}

export default withStyles({...styles})(connect(null,null)(SymbolsModal));



// WEBPACK FOOTER //
// ./src/views/Profiles/Wizard/SymbolsModal.jsx